/******************************************************************************
 *
 * ExecutionDrawer
 *
 * Right-side execution workspace.
 *
 * Responsibilities
 *
 * ✓ Display selected Work Item
 * ✓ Execute Checklist
 * ✓ Capture Responses
 * ✓ Upload Evidence
 * ✓ Complete Work Item
 *
 ******************************************************************************/

import React, { useState } from "react";

import ExecutionHeader from "./execution/ExecutionHeader";
import WorkItemSummary from "./execution/WorkItemSummary";
import ExecutionProgress from "./execution/ExecutionProgress";
import ChecklistSection from "./execution/ChecklistSection";

export default function ExecutionDrawer({

    open,

    onClose,

    work,

    workItem,

    checklists = []

}) {

    const [maximized, setMaximized] = useState(false);

    if (!open) return null;

    return (

        <div
            className="position-fixed top-0 end-0 bg-white shadow-lg d-flex flex-column"
            style={{

                width: maximized ? "100vw" : "780px",

                height: "100vh",

                zIndex: 1080,

                transition: "all .25s ease",

                borderLeft: "1px solid #dee2e6"

            }}
        >

            {/* ====================================================== */}
            {/* Header (Fixed) */}
            {/* ====================================================== */}

            <ExecutionHeader

                work={work}

                workItem={workItem}

                maximized={maximized}

                onToggleMaximize={() =>
                    setMaximized(!maximized)
                }

                onClose={onClose}

            />

            {/* ====================================================== */}
            {/* Scrollable Body */}
            {/* ====================================================== */}

            <div
                className="flex-grow-1 overflow-auto"
                style={{
                    background: "#f8fafc"
                }}
            >

                <div className="p-3">

                    <WorkItemSummary

                        workItem={workItem}

                    />

                    <ExecutionProgress

                        workItem={workItem}

                        checklists={checklists}

                    />

                    <ChecklistSection

                        checklists={checklists}

                    />

                </div>

            </div>

        </div>

    );

}